import { StreamType } from '@components/chat/shared/useStreamChat';
import { useTranslate } from 'nucleus-text';
import { ChannelMemberResponse } from 'stream-chat';

/**
 * Helper function for getting the name to display for a channel.
 * members: an array of channel members that returns the channel name
 * depending on whether it is a 1-1 or group messaging channel.
 * streamChannelName: Passed in for Group Messages that have a channel name
 * set by the attendee and overrides other display formats.
 */
export const useChannelName = (members: ChannelMemberResponse<StreamType>[], streamChannelName?: string) => {
  const { translate } = useTranslate();
  const isOneOnOne = members.length === 1;
  const maxGroupNamesToDisplay = 5;

  // Early returns
  if (members.length < 0) return '';
  if (streamChannelName) return streamChannelName;

  if (isOneOnOne) {
    return translate('Universal-FullName', {
      firstName: members[0].user.firstName,
      lastName: members[0].user.lastName
    });
  }

  // Group message
  const attendeeNames = members.slice(0, maxGroupNamesToDisplay).reduce(
    (acc, member, index) =>
      member.user.firstName && member.user.lastName
        ? `${acc}${index !== 0 ? ',' : ''} ${translate('Universal-FullName', {
            firstName: member.user.firstName,
            lastName: member.user.lastName
          })}`
        : '',
    ''
  );

  if (members.length <= maxGroupNamesToDisplay) return attendeeNames;

  return `${attendeeNames}, ${translate('AttendeeMessaging-Group-Channel-Name-Remaining-Count', {
    remaining: members.length - maxGroupNamesToDisplay
  })}`;
};
